import React from 'react'

export const ClosedLargeIcon = () => {
  return (
  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
      <g clipPath="url(#clip0_6078_71121)">
        <path d="M23.3326 49.5507L15.7609 34.405L0.615234 26.8333L15.7609 19.2617L23.3326 4.116L30.9042 19.2617L46.0499 26.8333L30.9042 34.405L23.3326 49.5507ZM11.0499 26.8333L19.2376 30.9283L23.3326 39.116L27.4276 30.9283L35.6152 26.8333L27.4276 22.7383L23.3326 14.5507L19.2376 22.7383L11.0499 26.8333ZM41.9992 49L45.4992 56L48.9992 49L55.9992 45.5L48.9992 42L45.4992 35L41.9992 42L34.9992 45.5L41.9992 49ZM45.1096 10.8897L47.8326 16.3333L50.5556 10.8897L55.9992 8.16667L50.5556 5.44367L47.8326 0L45.1096 5.44367L39.6659 8.16667L45.1096 10.8897Z" fill="#76CFEB"/>
      </g>
      <defs>
        <clipPath id="clip0_6078_71121">
          <rect width="56" height="56" fill="white"/>
        </clipPath>
      </defs>
  </svg>
  )
}
